import { gql } from '@apollo/client';
import { Boolean, DateTime, ID, Int, JSONObject, String } from '../get-real-estates';
import { PaginationOf } from '../get-user-saved-real-estate';

export enum NotificationKind {
  common = 'common',
  posted = 'posted',
  suitableRealEstate = 'suitableRealEstate',
  projectService = 'projectService',
  productService = 'productService',
  other = 'other',
  addFriend = 'addFriend',
}
export enum NotificationType {
  simpleNotiFromAdmin = 'simpleNotiFromAdmin',
  requestPremiumUserApproved = 'requestPremiumUserApproved',
  requestPremiumUserRefused = 'requestPremiumUserRefused',
  requestCompanyUserApproved = 'requestCompanyUserApproved',
  requestCompanyUserRefused = 'requestCompanyUserRefused',
  requestConnectToDeveloper = 'requestConnectToDeveloper',
  totalScheduleToday = 'totalScheduleToday',
  userBookSchedule = 'userBookSchedule',
  userChangeSchedule = 'userChangeSchedule',
  userCancelSchedule = 'userCancelSchedule',
  posterCancelSchedule = 'posterCancelSchedule',
  suitablePostingWithSavedFilters = 'suitablePostingWithSavedFilters',
  suitableDemandWithYourPost = 'suitableDemandWithYourPost',
  expiredPostingsToday = 'expiredPostingsToday',
  paymentSuccessfully = 'paymentSuccessfully',
  paymentFailed = 'paymentFailed',
  paymentFailedRefund = 'paymentFailedRefund',
  addToDepartment = 'addToDepartment',
  assignNewPosition = 'assignNewPosition',
  sharedNeed = 'sharedNeed',
  sharedProject = 'sharedProject',
  newComment = 'newComment',
  replyComment = 'replyComment',
  updatePermission = 'updatePermission',
  newFriendRequest = 'newFriendRequest',
  beFriend = 'beFriend',
  likePost = 'likePost',
  commentOnPost = 'commentOnPost',
  acceptedFriendRequest = 'acceptedFriendRequest',
  likeComment = 'likeComment',
  tagged = 'tagged',
  newPost = 'newPost',
}
export interface Notification {
  id?: ID;
  preview?: String;
  title?: String;
  body?: String;
  type?: NotificationType;
  group?: NotificationKind;
  createdAt?: DateTime;
  updatedAt?: DateTime;
  deletedAt?: DateTime;
  readAt?: DateTime;
  payload?: JSONObject;
  system?: String;
  service?: String;
}
export interface PaginationOfNotification extends PaginationOf {
  items?: Notification[];
  statistics?: JSONObject;
}

export interface MyNotificationsData {
  myNotifications?: PaginationOfNotification;
}
export interface MyNotificationsVariables {
  page?: Int;
  limit?: Int;
  searchString?: String;
  group?: NotificationKind[];
  isSocialNoti?: Boolean;
}

export const MY_NOTIFICATIONS = gql`
  query myNotifications(
    $page: Int
    $limit: Int
    $searchString: String
    $group: [NotificationKind]
    $isSocialNoti: Boolean
  ) @api(name: common) {
    myNotifications(
      page: $page
      limit: $limit
      searchString: $searchString
      group: $group
      isSocialNoti: $isSocialNoti
    ) {
      items {
        body
        createdAt
        deletedAt
        updatedAt
        group
        id
        payload
        preview
        readAt
        title
        type
      }
      statistics
      hasNextPage
      hasPrevPage
      limit
      nextPage
      page
      pagingCounter
      prevPage
      total
      totalPages
    }
  }
`;
